import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import RosterForm from '../components/forms/RosterForm';
import '../styles/EmployeeMaster.css';
import RosterTable from '../components/RosterTable';

const RosterModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/roster/add';

  const handleAddClick = () => {
    navigate('/roster/add');
  };

  const handleCloseModal = () => {
    navigate('/roster');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Roster Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Roster
        </button>
      </div>

      <RosterTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Roster</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RosterForm />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RosterModel;
